module.exports = __webpack_public_path__ + "img/zcjg.975ee6ad.jpg";